<input id="file" type="file" *ngIf="!loading" #file style="display: none;" (change)="uploadFile($event.target)">
<div id="add-attachment" class="hover-bttn" (click)="clickFileSelect($event)">
    <ion-icon name="fa-plus" style="font-size: 18px;"></ion-icon>
</div>